import { render, staticRenderFns } from "./TimerDashboard.vue?vue&type=template&id=bd96646c&scoped=true&"
import script from "./TimerDashboard.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TimerDashboard.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd96646c",
  null
  
)

export default component.exports